import 'src/asset/css/theme/bootstrap.css';
import 'src/asset/css/theme/style.css';
import 'src/asset/css/theme/style-responsive.css';
import 'src/asset/css/theme/animate.css';
import 'src/asset/css/theme/vertical-rhythm.css';
import 'src/asset/css/theme/owl.carousel.css';
import 'src/asset/css/theme/magnific-popup.css';
import 'src/asset/css/theme/YTPlayer.css';
import 'src/asset/css/theme/et-line/style.css';
import 'src/asset/css/style.custom.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(
    <CookiesProvider><App /></CookiesProvider>,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx